import { render, staticRenderFns } from "./CoverageFocus.vue?vue&type=template&id=ae2eceb8&scoped=true&"
import script from "./CoverageFocus.vue?vue&type=script&lang=js&"
export * from "./CoverageFocus.vue?vue&type=script&lang=js&"
import style0 from "./CoverageFocus.vue?vue&type=style&index=0&id=ae2eceb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2eceb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
